import React, { createContext, useState } from 'react';
import { useMultiAudio } from '../hooks/useAudio';

interface AudioContextValue {
  muted: boolean;
  toggleMute(event: React.ChangeEvent<HTMLInputElement>): void;
  play(key: any): void;
  playBg(key: any): void;
}

const AudioContext = createContext<AudioContextValue>({
  muted: false,
  toggleMute() { },
  play() { },
  playBg() { }
});

const AudioProvider = (props: any) => {
  const [muted, setMuted] = useState(localStorage.getItem('audio') ? true : false);
  const [toggle, toggleBg, toggleGroup] = useMultiAudio();

  const toggleMute = () => {
    if (!muted) {
      localStorage.setItem('audio', `true`);
      setMuted(true);
    } else {
      localStorage.removeItem('audio');
      setMuted(false);
    }
  };

  const play = (audioKey: any) => {
    if (muted) return;
    if (typeof audioKey === 'string') {
      toggleGroup(audioKey);
    } else {
      toggle(audioKey);
    }
  }

  const playBg = (audioKey: any) => {
    if (muted) return;
    toggleBg(audioKey);
  }

  return (
    <div>
      <AudioContext.Provider value={{ muted, toggleMute, play, playBg }}>
        {props.children}
      </AudioContext.Provider>
    </div>
  )
};

export { AudioContext, AudioProvider };
